import React, {Component} from 'react';
import {
  MenuFilter,
  SearchBox,
  Select,
  TopBar
} from 'searchkit';
import { SearchLabel } from './styles/SearchLabel';
import Responsive from 'react-responsive';

class LayoutHeader extends Component {
  render() {
    const Mobile = props => <Responsive {...props} maxWidth={1024} />;

    return (
      <div className="uk-container">
        <TopBar>
          <Mobile>
            <h1 className="uk-text-bold">Search Results</h1>
          </Mobile>
          <div className="uk-grid">
            <div className="uk-width-1-2@m uk-width-1-1@s m-margin-bt-20">
              <SearchLabel>What</SearchLabel>
              <SearchBox
                searchOnChange={true}
                searchThrottleTime={600}
                placeholder="What are you looking for?"
                prefixQueryFields={["_all"]}
                queryFields={["_all"]}/>
            </div>
            <div className="uk-width-1-2@m uk-width-1-1@s">
              <SearchLabel>Where</SearchLabel>
              <MenuFilter
                id='city'
                field='city'
                listComponent={Select} />
              <button className="btn lg-btn primary-btn search-btn" onClick={this.reloadSearch}>Find</button>
            </div>
          </div>
        </TopBar>
      </div>
    );
  }
}

export default LayoutHeader;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/LayoutHeader.jsx